import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FilterBlock} from '../filter-block';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/internal/operators';
import {TranslateService} from '../../../../../shared/translate.service';

@Component({
  selector: 'app-filter-common-header',
  templateUrl: './filter-common-header.component.html',
  styleUrls: ['./filter-common-header.component.css']
})
export class FilterCommonHeaderComponent implements OnInit {

  @Input() simpleFilterAllowed = false;

  @Input() count;

  @Input() blockId: string = 'NoID';

  @Input() selectId: string = 'quick-filter-items-input';

  @Input() countVisible = true;

  @Output() quickFilterEvent = new EventEmitter<string>();

  quickField = new FormControl();

  private _filterBlock: FilterBlock;

  get filterBlock(): FilterBlock {
    return this._filterBlock;
  }

  @Input()
  set filterBlock(value: FilterBlock) {
    this._filterBlock = value;
    if (!this.count) {
      this.count = value.filters.filter(filter => filter.count > 0).length;
    }
  }

  constructor(public translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.quickField.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => this.quickFilterEvent.emit(value));
  }

  preventDef(event) {
    if (event) {
      event.preventDefault();
    }
  }

  isHideFilter() {
    return this._filterBlock.filterConfig.hideSearch && !this._filterBlock.filterConfig.hide;
  }

  toggleHideFilter() {
   if (this._filterBlock.filterConfig.hide) {
     this.toggleHide();
     this._filterBlock.filterConfig.hideSearch = true;
   } else {
     this._filterBlock.filterConfig.hideSearch = !this._filterBlock.filterConfig.hideSearch;
   }
  }

  isHide() {
    return this._filterBlock.filterConfig.hide;
  }

  toggleHide() {
    this._filterBlock.filterConfig.hide = !this._filterBlock.filterConfig.hide;
  }

  getBlockLabel(){
    return this.translateService.translate(this._filterBlock.filterConfig.translation);
  }

  hideLabel() {
    if (this.isHide()) {
      return this.translateService.translate('FilterBlock.show')+' '+this.getBlockLabel();
    } else {
      return this.translateService.translate('FilterBlock.hide')+' '+this.getBlockLabel();
    }
  }

  hideFilterLabel(){
    if (!this.isHideFilter()){
      return this.translateService.translate('FilterBlock.quick.show')+' '+this.getBlockLabel();
    }else{
      return this.translateService.translate('FilterBlock.quick.hide')+' '+this.getBlockLabel();
    }
  }
}
